<template>
  <input type="text" v-model="name" placeholder="Enter your name">
</template>

<script>
export default {
  name: 'input-component',
  data() {
    return {
      name: null
    }
  }
}
</script>

<style lang="scss">
  input {
    padding: 15px 25px;
    border-radius: 30px;
    border: none;
    font-size: 18px;
    font-family: 'Roboto Condensed', sans-serif;
    background: url('~@/assets/person-icon.png') no-repeat scroll 20px 10px #fff;
    padding-left:60px;
  }
</style>
